// BangaloreLocations.jsx
import "./bangalore.css";
import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import favicon from './../../../assets/images/favicon.ico';
const BangaloreLocations = () => {
  const [activeDoctor, setActiveDoctor] = useState('DR.JHOTHI');

  const doctorContent = {
    'DR.JHOTHI': {
      title: 'Dr. Jhothi',
      specialty: 'Chronic Diseases Specialist',
      description: 'Dr. Jhothi is an experienced homeopathic physician specializing in chronic diseases. With over 15 years of practice, she has successfully treated numerous cases of diabetes, arthritis, and respiratory conditions.',
      experience: '15+ years',
      expertise: [
        'Diabetes Management',
        'Arthritis Treatment',
        'Respiratory Disorders',
        'Chronic Pain Management'
      ]
    },
    'DR.SPOORTHI': {
      title: 'Dr. Spoorthi',
      specialty: "Women's Health Expert",
      description: 'Dr. Spoorthi specializes in women\'s health issues and has helped countless patients with PCOS, fertility issues, and hormonal imbalances using homeopathic treatments.',
      experience: '10+ years',
      expertise: [
        'PCOS Treatment',
        'Fertility Issues',
        'Hormonal Balance',
        'Pregnancy Care'
      ]
    },
    'DR.NILOFER': {
      title: 'Dr. Nilofer',
      specialty: 'Skin & Hair Specialist',
      description: 'Dr. Nilofer is a renowned specialist in treating skin and hair conditions through homeopathy. Her expertise includes treating chronic skin conditions and hair loss problems.',
      experience: '12+ years',
      expertise: [
        'Skin Disorders',
        'Hair Loss Treatment',
        'Acne Management',
        'Psoriasis Care'
      ]
    },
    'DR.VENA': {
      title: 'Dr. Vena',
      specialty: 'Pediatric Care Expert',
      description: 'Dr. Vena specializes in pediatric care and has extensive experience in treating children\'s health issues with gentle homeopathic remedies.',
      experience: '8+ years',
      expertise: [
        'Child Healthcare',
        'Growth & Development',
        'Behavioral Issues',
        'Immunity Boosting'
      ]
    },
    'DR.RENUKA Treatment Plan': {
      title: 'Dr. Renuka',
      specialty: 'General Physician',
      description: 'Dr. Renuka provides comprehensive treatment plans focusing on overall wellness and chronic disease management through homeopathy.',
      experience: '13+ years',
      expertise: [
        'Wellness Programs',
        'Chronic Disease Management',
        'Lifestyle Disorders',
        'Preventive Care'
      ]
    }
  };
  const [currentImageIndex, setCurrentImageIndex] = useState({
    Jayanagar: 0,
    Whitefield: 0,
  });

  const locations = [
    {
      name: "Jayanagar",
    address: "#779, 9th Block, Jayanagar\nBangalore - 560041",
    images: [
      require('./../../../assets/images/hcurahomeopathyjayanagaraclinic.jpg'),
  
    ],
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8554375130057!2d77.5931845739414!3d12.917011416075074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14d8dd315555%3A0x837b338b42d71825!2sH-Cura%20Homeopathy%20Clinic%2C%20Jayanagar%2C%20Bangalore!5e0!3m2!1sen!2sin!4v1736335344712!5m2!1sen!2sin",
    },
    {
      name: "Whitefield",
      address: "Whitefield Main Road\nBangalore - 560066",
      images: [
        require('./../../../assets/images/whitefieldhcurahomeopathyclinic.jpg'),
      ],
      mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.8554375130057!2d77.5931845739414!3d12.917011416075074!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae14d8dd315555%3A0x837b338b42d71825!2sH-Cura%20Homeopathy%20Clinic%2C%20Jayanagar%2C%20Bangalore!5e0!3m2!1sen!2sin!4v1736335344712!5m2!1sen!2sin",
    },
  ];

  useEffect(() => {
    const intervals = locations.map((location) => {
      return setInterval(() => {
        setCurrentImageIndex((prev) => ({
          ...prev,
          [location.name]: (prev[location.name] + 1) % location.images.length,
        }));
      }, 3000);
    });

    return () => intervals.forEach((interval) => clearInterval(interval));
  }, []);
  useEffect(() => {
                   document.title = "H-Cura Homeopathy Clinics in Bangalore - Expert Homeopathic Treatment Across the City";
                   const metaDescription = document.querySelector("meta[name='description']");
                   if (metaDescription) {
                     metaDescription.setAttribute(
                       "content",
                       "Discover H-Cura Homeopathy’s clinics across Bangalore, offering expert homeopathic treatment for a variety of health conditions. Our skilled doctors provide holistic, personalized care at convenient locations throughout the city. Book an offline consultation today for effective remedies."
                     );
                   }
                   const metaKeywords = document.querySelector("meta[name='keywords']");
                   if (metaKeywords) {
                     metaKeywords.setAttribute(
                       "content",
                       "Homeopathy clinic in Bangalore, Homeopathic treatment in Bangalore, Best homeopathy doctors in Bangalore, Homeopathy for skin treatment in Bangalore, Hair fall treatment in Bangalore, Natural treatment clinic in Bangalore, Jayanagar homeopathy clinic, Bangalore homeopathy consultation, Homeopathy for joint pain in Bangalore, Homeopathy for stress and anxiety in Bangalore, Homeopathic remedies in Bangalore, Multispeciality homeopathy clinic in Bangalore, Bangalore homeopathy for chronic diseases, Homeopathy clinic near Jayanagar Bangalore, Homeopathy treatment for women in Bangalore, Homeopathy for children's health in Bangalore."
                     );
                   }
                    // Set canonical link
                    const existingCanonical = document.querySelector("link[rel='canonical']");
                    if (existingCanonical) {
                      existingCanonical.setAttribute("href", "https://www.h-cura.com/homeopathy-clinic-in-bangalore/");
                    } else {
                      const canonicalLink = document.createElement("link");
                      canonicalLink.setAttribute("rel", "canonical");
                      canonicalLink.setAttribute("href", "https://www.h-cura.com/homeopathy-clinic-in-bangalore/");
                      document.head.appendChild(canonicalLink);
                    }
                    // Set favicon
                 const existingFavicon = document.querySelector("link[rel='icon']");
                 if (existingFavicon) {
                   existingFavicon.setAttribute("href", favicon);
                 } else {
                   const faviconLink = document.createElement("link");
                   faviconLink.setAttribute("rel", "icon");
                   faviconLink.setAttribute("type", "image/x-icon");
                   faviconLink.setAttribute("href", favicon);
                   document.head.appendChild(faviconLink);
                 }
                 }, []);

  return (
    <div className="bangalore-page-container">
      <div className="bangalore-side-nav">
        <h2 className="bangalore-side-title">Our Locations</h2>
        <div className="bangalore-nav-links">
          <Link to="/homeopathy-clinic-in-jayanagar-bangalore/" className="bangalore-nav-btn">
            Jayanagar
          </Link>
          {/* <Link to="/whitefield" className="bangalore-nav-btn">
            Whitefield
          </Link> */}
        </div>
      </div>
      <div className="bangalore-main-content">
        {/* Main Header */}
        <div className="bangalore-main-header">
          <h1 className="bangalore-clinic-title">
            H-Cura Homeopathy Clinic - Bangalore
          </h1>
          <p className="bangalore-clinic-tagline">
            Your Trusted Partner in Holistic Healing
          </p>
        </div>

        {/* Welcome Section */}
        <div class="bangalore-welcome-section">
          <h2 class="bangalore-welcome-heading">
            Welcome to H-Cura Homeopathy's Bangalore Clinic
          </h2>
          <div class="bangalore-welcome-text">
            <p>
              Welcome to H-Cura Homeopathy’s Bangalore clinic, where holistic
              health and compassionate care come together. Conveniently located
              in Jayanagar, our Bangalore clinic is designed to provide a
              welcoming and healing environment for all our patients. Whether
              you’re seeking treatment for chronic conditions, skin and hair
              issues, or lifestyle disorders, our expert doctors are here to
              guide you every step of the way.
            </p>
          </div>
        </div>

        {/* Features Section */}
        <section className="bangalore-features">
          <h2 className="bangalore-section-title">
            Why Choose Our Bangalore Clinic?
          </h2>
          <div className="bangalore-features-grid">
            <div className="bangalore-feature-card">
              <h3 className="bangalore-feature-title">Central Location</h3>
              <p className="bangalore-feature-description">
                Our Jayanagar clinic is easily accessible, with a peaceful
                setting that fosters healing and comfort.{" "}
              </p>
            </div>

            <div className="bangalore-feature-card">
              <h3 className="bangalore-feature-title">Expert Team</h3>
              <p className="bangalore-feature-description">
                The clinic is staffed by experienced homeopathic specialists who
                bring their vast expertise to treat a variety of health concerns{" "}
              </p>
            </div>

            <div className="bangalore-feature-card">
              <h3 className="bangalore-feature-title">
                State-of-the-Art Facilities
              </h3>
              <p className="bangalore-feature-description">
                Equipped with modern amenities and a patient-friendly design,
                our clinic ensures a seamless healthcare experience{" "}
              </p>
            </div>

            <div className="bangalore-feature-card">
              <h3 className="bangalore-feature-title">Holistic Treatments</h3>
              <p className="bangalore-feature-description">
                From acute ailments to chronic diseases, our treatments address
                the root cause and promote overall well-being{" "}
              </p>
            </div>

            <div className="bangalore-feature-card">
              <h3 className="bangalore-feature-title">Personalized Care</h3>
              <p className="bangalore-feature-description">
                We prioritize your health journey, offering tailored solutions
                to meet your specific needs.
              </p>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="bangalore-services">
          <h2 className="bangalore-section-title">
            Services Offered at Bangalore Clinic
          </h2>
          <div className="bangalore-services-grid">
            <div className="bangalore-service-card">
              <h3 className="bangalore-service-title">Skin & Hair Care</h3>
              <ul className="bangalore-service-list">
                <li className="bangalore-service-item">Acne Treatment</li>
                <li className="bangalore-service-item">Psoriasis Management</li>
                <li className="bangalore-service-item">Hair Fall Solutions</li>
              </ul>
            </div>

            <div className="bangalore-service-card">
              <h3 className="bangalore-service-title">Respiratory Health</h3>
              <ul className="bangalore-service-list">
                <li className="bangalore-service-item">Asthma Treatment</li>
                <li className="bangalore-service-item">Bronchitis Care</li>
                <li className="bangalore-service-item">Sinusitis Management</li>
              </ul>
            </div>

            <div className="bangalore-service-card">
              <h3 className="bangalore-service-title">Chronic Illnesses</h3>
              <ul className="bangalore-service-list">
                <li className="bangalore-service-item">Arthritis Treatment</li>
                <li className="bangalore-service-item">Thyroid Management</li>
                <li className="bangalore-service-item">Autoimmune Conditions</li>
              </ul>
            </div>

            <div className="bangalore-service-card">
              <h3 className="bangalore-service-title">Women's Health</h3>
              <ul className="bangalore-service-list">
                <li className="bangalore-service-item">Expert care for PCOS</li>
                <li className="bangalore-service-item">Menstrual Issues</li>
                <li className="bangalore-service-item">infertility</li>
              </ul>
            </div>

            <div className="bangalore-service-card">
              <h3 className="bangalore-service-title">Mental Health</h3>
              <ul className="bangalore-service-list">
                <li className="bangalore-service-item">Holistic treatments</li>
                <li className="bangalore-service-item">Anxiety</li>

                <li className="bangalore-service-item">Depression</li>
                <li className="bangalore-service-item">Stress Management</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Doctors Section */}
        <section className="bangalore-doctors">
      <h2 className="bangalore-doctors-title">
        Expert Doctors at Our Bangalore Clinics
      </h2>
      
      <div className="bangalore-doctors-tabs">
        {Object.keys(doctorContent).map((doctor) => (
          <button
            key={doctor}
            className={`bangalore-doctor-tab ${activeDoctor === doctor ? 'active' : ''}`}
            onClick={() => setActiveDoctor(doctor)}
          >
            {doctor}
          </button>
        ))}
      </div>

      <div className="bangalore-doctors-content">
        {doctorContent[activeDoctor] && (
          <div className="bangalore-doctor-details">
            <h2 className="bangalore-doctor-name">{doctorContent[activeDoctor].title}</h2>
            <h3 className="bangalore-doctor-specialty">{doctorContent[activeDoctor].specialty}</h3>
            <p className="bangalore-doctor-description">{doctorContent[activeDoctor].description}</p>
            <div className="bangalore-doctor-experience">
              Experience: {doctorContent[activeDoctor].experience}
            </div>
            <div className="bangalore-doctor-expertise">
              <h4 className="bangalore-expertise-title">Areas of Expertise:</h4>
              <ul className="bangalore-expertise-list">
                {doctorContent[activeDoctor].expertise.map((item, index) => (
                  <li key={index} className="bangalore-expertise-item">{item}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
      </div>
    </section>

        {/* Location Details */}
        <section className="clinic-locations">
          <h2 className="section-title">Visit Our Clinic</h2>

          <div className="locations-grid">
            {locations.map((location, index) => (
              <div key={index} className="location-card">
                <h3 className="location-name">{location.name}</h3>

                <div className="image-carousel">
                  {location.images.map((image, imgIndex) => (
                    <img
                      key={imgIndex}
                      src={image}
                      alt={`${location.name} clinic view ${imgIndex + 1}`}
                      className={`carousel-image ${
                        currentImageIndex[location.name] === imgIndex
                          ? "active"
                          : ""
                      }`}
                    />
                  ))}
                </div>

                <div className="address-container">
                  <p className="address-text">
                    {location.address.split("\n").map((line, i) => (
                      <React.Fragment key={i}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </p>
                </div>

                <div className="map-container">
                  <iframe
                    src={location.mapUrl}
                    className="map-frame"
                    title={`${location.name} clinic location`}
                    allowFullScreen
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </section>
        {/* CTA Section */}
        <section className="appointment-cta">
          <h2 className="appointment-cta__title">
            Book Your Appointment Today
          </h2>
          <p className="appointment-cta__text">
            Take the first step toward a healthier life with H-Cura Homeopathy.
            Visit our clinics in Madanandapuram or Valasaravakkam, Chennai, or
            book an online consultation for expert care wherever you are.
            Experience holistic healing and lasting results with H-Cura
            Homeopathy – your trusted homeopathy clinic in Chennai.
          </p>
          <button className="appointment-cta__button">
            Schedule Consultation
          </button>
        </section>
      </div>
    </div>
  );
};

export default BangaloreLocations;